<template>
    <NcTabs :modelValue="activeKey" :tabs="tabs" @update:modelValue="onSelect" />
</template>

<script>
import { db } from '@/services/db';

// Gedeelde tab-balk over de drie inspectie-werkschermen (Informatie / Structuur
// / Metingen). De schermen blijven losse routes met hun eigen header-acties en
// Ionic-lifecycle; deze balk navigeert er met router.replace tussen, zodat
// tabwissels niet op de history-stack stapelen en de terug-knop naar de
// inspectie-hub blijft gaan.
export default {
    name: 'InspectionTabBar',
    data() {
        return {
            tabs: [
                { key: 'information', label: 'Informatie', icon: 'information-outline' },
                { key: 'structure', label: 'Structuur', icon: 'file-tree-outline' },
                { key: 'measurements', label: 'Metingen', icon: 'ruler-square' },
            ],
        };
    },
    computed: {
        activeKey() {
            switch (this.$route.name) {
                case 'inspection-information': return 'information';
                case 'location-item-tree': return 'structure';
                case 'measurement-bulk': return 'measurements';
                default: return '';
            }
        },
    },
    methods: {
        async onSelect(key) {
            if (key === this.activeKey) return;

            const id = this.$store.getters.getInspectionId;

            if (key === 'information') {
                this.$router.replace({ name: 'inspection-information', params: { id } });
                return;
            }

            if (key === 'structure') {
                // De structuurheader toont de inspectienaam; die staat niet in de
                // store, dus halen we hem uit de DB (val terug op de bestaande
                // 'Uitvoering'-default wanneer hij ontbreekt).
                const inspection = id != null
                    ? await db.inspections.where('id').equals(id).first()
                    : null;
                this.$router.replace({
                    name: 'location-item-tree',
                    params: { id },
                    query: {
                        location_id: this.$store.getters.getLocationId,
                        inspection_name: inspection ? inspection.name : undefined,
                        inspection_uuid: this.$store.getters.getInspectionUuid,
                    },
                });
                return;
            }

            if (key === 'measurements') {
                this.$router.replace({ name: 'measurement-bulk' });
            }
        },
    },
};
</script>
